<template>
  <div class="success-page-wrap">
    
    <div class="success-page" ref="document">
      <div class="full-page-wrap">
        <div class="success-content">
          <div class="success-header-wrap">
            <div class="success-icon">
              <img src="@/assets/images/check2.svg" alt="" />
            </div>
          </div>
          <div class="success-body-wrap">
            <h2>Payment Successfull</h2>
            <div class="payment-info-list">
              <div
                class="info-box"
                v-for="(value, key) in customerDetail"
                :key="key"
              >
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(key) }} </v-list-item-title>
                    <v-list-item-subtitle :title="value">{{
                      value
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
            <p>
              Your payment have been successfully made through link pay. Thank
              you for choosing link pay.
            </p>
            <span class="btn btn-primary" @click="downloadPdf"
              >Download PDF <span class="mdi mdi-file-pdf btn-icon-left"></span
            ></span>
          </div>
        </div>
      </div>
    </div>
        
    <!-- <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="detail"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="payment-pdf-content">
          <div class="pdf-body-wrap">
            <h6>Payment Detail</h6>
            <div class="pdf-info-list">
              <div
                class="pdf-info-box"
                v-for="(value, key) in customerDetail"
                :key="key"
              >
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(key) }} </v-list-item-title>
                    <v-list-item-subtitle>{{ value }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
            
          </div>
        </div>
      </section>
    </vue-html2pdf> -->
  </div>
</template>
<script>
// import VueHtml2pdf from "vue-html2pdf";
	import html2pdf from 'html2pdf.js'
import Promise from "../../lib/mixins/ExtendedPromises";
import Payment from "../../repositories/payment";
import moment from "moment";
export default {
  name: "Success",
  mixins: [Promise],
  components: {
    // VueHtml2pdf
  },
  mounted() {
    this.getPostData();
  },
  data() {
    return {
      merchantLogo: "",
      customerDetail: {}
    };
  },
  methods: {
    formateDate(val) {
      return moment(val).format("MMM Do YYYY");
    },
    getPostData() {
      let id = this.$route.params.id;      
      const operation = this.response(Payment.getPaymentDetail(id));
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.merchantLogo = response.data.merchantLogoUrl;
            this.customerDetail = response.data;
            this.customerDetail.paymentDate = this.formateDate(
              this.customerDetail.paymentDate
            );
            this.customerDetail.linkCreatedDate = this.formateDate(
              this.customerDetail.linkCreatedDate
            );
            delete this.customerDetail.merchantLogoUrl;
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    downloadPdf() {
      // this.$refs.html2Pdf.generatePdf();
      html2pdf(this.$refs.document, {
					margin: 1,
					filename: 'document.pdf',
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas: { dpi: 1, letterRendering: true },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
				})
    }
  }
};
</script>
<style lang="scss">
.payment-pdf-content {
  background: white;
  max-width: 100%;
  margin: 0 auto;
  padding: 1rem;
  text-align: center;
  .d-block {
    display: block;
  }
}
</style>
